import * as React from 'react';

import {Avatar} from '../avatar/avatar';
import {ButtonCard} from '../card/button-card';
import {colors} from '../colors/colors';
import {ContactMethodStatuses} from '../contact-method-statuses/contact-method-statuses';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {Link} from '../link/link';
import {Body} from '../typography/body';

import {AccountDetails} from './account-details';
import type {Account} from './account-details';

import styles from './prospector-card.module.css';

type Contact = {
    name: string;
    initials: string;
    jobTitle: string | null | undefined;
    department: string | null | undefined;
    location: string | null | undefined;
};

type Props = {
    contact: Contact;
    account: Account;
    isSelected: boolean;
    hasEmail: boolean;
    hasPhone: boolean;
    hasLinkedinUrl: boolean;
    onClick: () => void;
};

export function ProspectorCard(props: Props) {
    const {contact, account} = props;

    return (
        <ButtonCard isFullWidth={true} onClick={props.onClick}>
            <div className={styles.container}>
                <StackLegacy spacing={16} isHorizontal={true} alignCenter={true}>
                    <input type='checkbox' checked={props.isSelected} readOnly={true} />
                    <Avatar
                        avatarUrl={null}
                        initials={contact.initials}
                        size={32}
                        color={colors.person}
                        type='contacts'
                    />
                    <StackLegacy spacing={4}>
                        <Body isBold={true}>{contact.name}</Body>
                        {contact.jobTitle && <Body>{contact.jobTitle}</Body>}
                        {contact.department && <Body>{contact.department}</Body>}
                        {contact.location && (
                            <Body size='small' color='light'>
                                {contact.location}
                            </Body>
                        )}
                    </StackLegacy>
                </StackLegacy>
                <StackLegacy spacing={8}>
                    <StackLegacy spacing={2}>
                        <Body isBold={true}>{account.name}</Body>
                        {account.websiteUrl && (
                            <Link
                                variant='primary'
                                size='small'
                                newTab={true}
                                href={account.websiteUrl}
                                shouldAddHttpProtocol={true}
                            >
                                {account.websiteUrl}
                            </Link>
                        )}
                    </StackLegacy>
                    <AccountDetails account={account} />
                </StackLegacy>
                <ContactMethodStatuses
                    hasEmail={props.hasEmail}
                    hasPhone={props.hasPhone}
                    hasLinkedinUrl={props.hasLinkedinUrl}
                />
            </div>
        </ButtonCard>
    );
}
